// extracted by mini-css-extract-plugin
module.exports = {"container":"PopularDrinks_container__20pMv","drinkName":"PopularDrinks_drinkName__3v4nh","drinkImg":"PopularDrinks_drinkImg__35QM2"};